const useLokiClient = () => {
  const { $fetchService } = useNuxtApp()
  const route = useRoute()

  const sendError = async (error: any) => {
    try {
      const params: ILokiErrorUpdate.Request = {
        errorMessage: error.message ?? 'unknown error',
        stack: error.stack ?? 'unknown stack',
        route: route.fullPath,
      }

      await $fetchService.post(PROXY_URL_MAP.LOKI_ERROR, params)
    } catch (error) {
      log(error)
    }
  }

  return {
    sendError,
  }
}

export default useLokiClient
